// extracted by mini-css-extract-plugin
export default {"container":"common_container__x9pse","link":"common_link__HgWer","spinner_container":"common_spinner_container__BHL3M"};